// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"290":"f8370578d1bc36fe","633":"bae2c2a91b78f513","822":"550ccd1df6f0a5b0"}[chunkId] + ".js";
};